import EviteModal from './evite_modal'

export class PopupModal {

  settings = {
    buttons: ['Cancel', 'Yes'],
    html: false,
    title: null,
    body: '',
    width: "480px",
    popup: true,
  };

  constructor(settings) {
    return new EviteModal(Object.assign({}, this.settings, settings))
  };
}

export default PopupModal;



// WEBPACK FOOTER //
// ./assets/es6/modal/popup_modal.es6